













import { Component, Prop, Vue } from 'vue-property-decorator';
import { User } from '@/design-system/constructs/JobTile/JobTileViewModel';
import JdsAvatar from '@/design-system/constructs/Avatar/JdsAvatar.vue';

/**
 * @status stable
 * @published $next
 * @changelog $next Published.
 */
@Component({
    components: {
        JdsAvatar,
    },
})
export default class JdsAvatarStack extends Vue {
    @Prop() users!: User[];

    @Prop({ default: 'white', type: String }) outlineColor!: 'white' | 'grey';
}
